import {
  ChangeDetectionStrategy,
  Component,
  signal,
  ViewEncapsulation,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SEOService } from '../../../../../core/services/seo.service';
import { LandingPageDataService } from '../../services/landing-post-data.service';

@Component({
  selector: 'app-post-details',
  templateUrl: './post-details.component.html',
  styleUrls: ['./post-details.component.scss', './quill-preview.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class PostDetailsComponent {
  safeHtml = signal<SafeHtml>('');

  constructor(
    public landingPageDataService: LandingPageDataService,
    private seoService: SEOService,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    this.safeHtml.set(
      this.sanitizer.bypassSecurityTrustHtml(
        this.landingPageDataService.details().pageInfo?.description,
      ),
    );
  }
}
